import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import MaisonsSearch from '../components/MaisonsSearch.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        const app = createApp({
            template: '<MaisonsSearch />',
            components: {
                MaisonsSearch
            },
            data() {
                return {}
            },
            mounted() {
            },
        })
        app.mount(self.el)
    }
}